import { createSlice } from '@reduxjs/toolkit';

import { initialState, settingsAdapter } from './settings.state';
import {
  settingsCompanyReducers,
  settingsGroupReducers,
  settingsStatReducers,
  settingsSubstitutesReducers,
  settingsEventTypeReducers,
  settingsEventTypeCatalogReducers,
  settingsEventTypeParticipantsReducers,
  settingsEventTypeEditReducers,
  settingsUploadTemplateReducers,
  settingsTemplatesReducer,
  settingsTemplatesPreviewReducers,
  settingsAttorneysListReducer,
  settingsAttorneysCompaniesReducers,
  settingsAttorneysUsersReducers,
  settingsAttorneyDetailReducers,
  settingsVacationsListReducer,
  settingsVacationStartReducer,
  settingsVacationsCreateReducer,
  settingsVacationsEditReducer,
  settingsVacationDetailReducers,
  settingsWidgetContentReducers,
  settingsSidebarReducer,
  settingsAccountReducers,
  settingsAccountDashboardReducers,
  settingsDashboardReducers,
  settingsPartitionsReducers,
  settingsQuickActionsReducer,
  settingsAccountUsersGroupsReducers,
  settingsAccountRoleModelReducers,
  settingsAccountBusinessTripsReducers,
  settingsAbsencesReducers,
  settingsWidgetTopNewsReducers,
  settingsFeedPostsReducers,
  settingsBirthdaysReducers,
} from './actions';

const settings = createSlice({
  name: 'settings',
  initialState: settingsAdapter.getInitialState(initialState),
  reducers: {},
  extraReducers: (builder) => {
    settingsSubstitutesReducers(builder);
    settingsCompanyReducers(builder);
    settingsStatReducers(builder);
    settingsGroupReducers(builder);
    settingsEventTypeReducers(builder);
    settingsEventTypeCatalogReducers(builder);
    settingsEventTypeParticipantsReducers(builder);
    settingsEventTypeEditReducers(builder);
    settingsUploadTemplateReducers(builder);
    settingsTemplatesReducer(builder);
    settingsTemplatesPreviewReducers(builder);
    settingsAttorneysListReducer(builder);
    settingsAttorneysCompaniesReducers(builder);
    settingsAttorneysUsersReducers(builder);
    settingsAttorneyDetailReducers(builder);
    settingsVacationsListReducer(builder);
    settingsVacationStartReducer();
    settingsVacationsCreateReducer(builder);
    settingsVacationsEditReducer(builder);
    settingsVacationDetailReducers(builder);
    settingsWidgetContentReducers(builder);
    settingsSidebarReducer(builder);
    settingsAccountReducers(builder);
    settingsAccountDashboardReducers(builder);
    settingsDashboardReducers(builder);
    settingsPartitionsReducers(builder);
    settingsQuickActionsReducer(builder);
    settingsAccountUsersGroupsReducers(builder);
    settingsAccountRoleModelReducers(builder);
    settingsAccountBusinessTripsReducers(builder);
    settingsAbsencesReducers(builder);
    settingsWidgetTopNewsReducers(builder);
    settingsFeedPostsReducers(builder);
    settingsBirthdaysReducers(builder);
  },
});

export const settingsReducer = settings.reducer;
